import { datetime } from "../../util/library/datetime";
import { NOTE_TYPE } from "../../util/varibles/constants";
import { getKeyWeek } from "../../util/varibles/global";
import { ILevelByVessel, INoteCalender, IOperation, IOperations, ISite, IVessel, IWellboats } from "../../util/varibles/interface";

export const CALENDAR_ID = 'content-calendar';

export const orderBySavedIds = <T extends { id: string }>(items: T[], savedIds: string[] = []) => {
    if (savedIds.length === 0)
        return items;

    const positions = new Map(savedIds.map((id, index) => [id, index]));
    return items
        .map((item, index) => ({ item, index }))
        .sort((first, second) => {
            const firstPosition = positions.get(first.item.id);
            const secondPosition = positions.get(second.item.id);
            if (firstPosition === undefined && secondPosition === undefined)
                return first.index - second.index;
            if (firstPosition === undefined)
                return 1;
            if (secondPosition === undefined)
                return -1;
            return firstPosition - secondPosition;
        })
        .map(({ item }) => item);
};

function createCurrentTime(): { weeks: any[] } {
    const weeks = [];
    const monday = datetime().startOf('week').value;
    for (let i = -7; i < 7; i++) {
        const time = datetime(monday).add(i, 'week').time;
        const key = getKeyWeek(time);
        weeks.push({ key, time });
    }
    return { weeks };
}

export function createKeyOfNote(time: number, type: NOTE_TYPE) {
    return [datetime(time).startOf('day').time, type].join('|')
}

export interface OverviewState {
    beforeCount: boolean
    afterCount: boolean

    operations: IOperations

    level: ILevelByVessel
    vessels: IVessel[]
    wellboats: IWellboats
    weeks: { key: string, time: number }[]
    loadingData: boolean
    loadingLazy: boolean
    showAllPlans: boolean
    notes: { [index: string]: INoteCalender[] }

    // Site side
    opsSite: {
        [id: string]: IOperation & { site_ids?: string[] }
    }
    sites: ISite[]

}

export const initialState: OverviewState = {
    beforeCount: false,
    afterCount: false,

    operations: {},
    level: {},
    vessels: [],
    wellboats: {
        operations: {},
        vessels: [],
        before_count: false,
        after_count: false,
    },
    loadingData: false,
    loadingLazy: false,
    showAllPlans: false,
    notes: {},
    ...createCurrentTime(),

    // Site side
    opsSite: {},
    sites: []
};
